export const BASE_URL = process.env.TOQIO_API_BASE_URL;
export const WORKFLOWS_BASE_URL = process.env.TOQIO_WORKFLOWS_BASE_URL;

export const api = {
  LOGIN: `iam/oauth/token`,
  REFRESH_TOKEN: `iam/oauth/token?grant_type=refresh_token`,
  PUBLIC_RSA_KEY: `iam/public/security/publicKey`,
  USER_PROFILE: `iam/users/me`,
  DYNAMIC_MENU: `dynamicmenu/menu`,
  CUSTOM_DYNAMIC_MENU: `custom-dynamic-menu/api/v1/menu`,
  PRIVATE_APPS: `workflows/db/private/apps`,
}